import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "wrapper", "previousButton", "nextButton"]
  static values = {
    index: {type: Number, default: 0},
  }
  static classes = ["hidden"]

  connect() {
    this._scrollToItem(this.indexValue, {behavior: "instant"})
    this.intersectionObserver = new IntersectionObserver(
      this._handleIntersectionObserver.bind(this),
      {
        root: this.wrapperTarget,
        threshold: 0.75,
      }
    )

    this.itemTargets.forEach((item) => this.intersectionObserver.observe(item))

  }

  next() {
    this._scrollToItem((this.indexValue + 1))
  }

  previous() {
    this._scrollToItem((this.indexValue - 1))
  }

  _scrollToItem(index, options = {}) {
    const {behavior = "smooth"} = options

    this.itemTargets[index].scrollIntoView({
      behavior: behavior
    })
  }

  _handleIntersectionObserver(entries) {
    entries.forEach((entry) => {
      const elem = entry.target
      const elemIndex = this.itemTargets.findIndex(
        (item) => item === elem
      )

      if (entry.isIntersecting && entry.intersectionRatio >= 0.75) {
        this.indexValue = elemIndex

        this._updateButtonsVisibility()
      }
    })
  }

  _updateButtonsVisibility() {
    this.previousButtonTarget.classList.remove(this.hiddenClass)
    this.nextButtonTarget.classList.remove(this.hiddenClass)

    if (this.indexValue === 0) {
      this.previousButtonTarget.classList.add(this.hiddenClass)
    }

    if (this.indexValue === this.itemTargets.length - 1) {
      this.nextButtonTarget.classList.add(this.hiddenClass)
    }
  }
}
